import React from 'react';
import styles from './styles.module.css';

/**
 * Abstract accompanying artwork for the detail rows.
 *
 * Drawn as SVG rather than sourced as photography for three reasons: it costs
 * no bytes over the wire beyond the markup, it takes the page's accent colour
 * so every feature page looks like itself, and it cannot go stale the way a
 * screenshot of a shipping product does.
 *
 * Purely decorative — every instance is rendered aria-hidden, and the row's
 * meaning lives entirely in its heading and body text.
 */

const Stack = ({ color }) => (
  <svg viewBox="0 0 320 220" className={styles.art}>
    {[0, 1, 2].map((i) => (
      <rect
        key={i}
        x={38 + i * 14} y={40 + i * 44} width={244 - i * 28} height={34} rx={10}
        fill={i === 1 ? color : `${color}22`}
        opacity={i === 1 ? 0.9 : 1}
        className={styles.artStack}
        style={{ animationDelay: `${i * 120}ms` }}
      />
    ))}
    <circle cx="160" cy="30" r="12" fill={`${color}33`} />
  </svg>
);

const Grid = ({ color }) => (
  <svg viewBox="0 0 320 220" className={styles.art}>
    {Array.from({ length: 12 }, (_, i) => (
      <rect
        key={i}
        x={40 + (i % 4) * 62} y={34 + Math.floor(i / 4) * 60}
        width={50} height={48} rx={12}
        fill={i % 5 === 0 ? color : `${color}1f`}
        className={styles.artCell}
        style={{ animationDelay: `${i * 45}ms` }}
      />
    ))}
  </svg>
);

const Timeline = ({ color }) => (
  <svg viewBox="0 0 320 220" className={styles.art}>
    <line x1="46" y1="110" x2="274" y2="110" stroke={`${color}33`} strokeWidth="4" strokeLinecap="round" />
    {[0, 1, 2, 3].map((i) => (
      <g key={i} className={styles.artNode} style={{ animationDelay: `${i * 110}ms` }}>
        <circle cx={60 + i * 67} cy="110" r={i === 1 ? 17 : 12} fill={i === 1 ? color : '#fff'} stroke={color} strokeWidth="3" />
        <rect x={60 + i * 67 - 22} y={i % 2 ? 138 : 60} width="44" height="14" rx="7" fill={`${color}26`} />
      </g>
    ))}
  </svg>
);

const Rings = ({ color }) => (
  <svg viewBox="0 0 320 220" className={styles.art}>
    {[74, 54, 34].map((r, i) => (
      <circle
        key={r}
        cx="160" cy="110" r={r}
        fill="none" stroke={i === 0 ? color : `${color}44`}
        strokeWidth={i === 0 ? 5 : 3}
        strokeDasharray={i === 0 ? '150 320' : undefined}
        strokeLinecap="round"
        className={styles.artRing}
        style={{ animationDelay: `${i * 140}ms` }}
      />
    ))}
    <circle cx="160" cy="110" r="12" fill={color} />
  </svg>
);

export const DEEP_DIVE_ART = [Stack, Grid, Timeline, Rings];
